import type { DevCleanupOptions } from "@/lib/settings.api";

export const CLEANUP_CONFIRMATION = "NETTOYER";

export const CLEANUP_OPTIONS: Array<{
  key: keyof DevCleanupOptions;
  title: string;
  description: string;
  tone: "danger" | "warning" | "neutral";
}> = [
  {
    key: "documents",
    title: "Documents commerciaux",
    description:
      "Proformas, factures, lignes, billets, paiements, échéanciers, bons de livraison et commissions compagnies associées.",
    tone: "danger",
  },
  {
    key: "partiesAndAccounts",
    title: "Parties, crédits et épargne",
    description:
      "Clients, référents, crédits, comptes épargne et leurs écritures. Les documents liés sont aussi nettoyés.",
    tone: "danger",
  },
  {
    key: "commissions",
    title: "Commissions et demandes",
    description:
      "Transactions de commission, demandes de modification et commissions compagnies (fournisseurs, lots de consolidation).",
    tone: "warning",
  },
  {
    key: "stock",
    title: "Stock PrestiShop",
    description:
      "Articles, quantités disponibles, mouvements de stock et demandes de modification de stock en attente.",
    tone: "warning",
  },
  {
    key: "notifications",
    title: "Notifications et e-mails",
    description: "Centre de notifications et historique d'envoi des e-mails.",
    tone: "neutral",
  },
  {
    key: "audit",
    title: "Journal d'audit",
    description: "Historique technique des actions. Une nouvelle trace de nettoyage sera recréée.",
    tone: "danger",
  },
  {
    key: "resetCounters",
    title: "Compteurs documents",
    description: "Remet les compteurs de numéros de documents à zéro pour les prochains essais.",
    tone: "warning",
  },
];

// Server returns raw snake_case table names in DevCleanupResult; map them to
// French labels for the result panel instead of printing them as-is.
export const CLEANUP_RESULT_LABELS: Record<string, string> = {
  company_commissions: "Commissions compagnies",
  company_commission_batches: "Lots de consolidation",
  company_commission_suppliers: "Fournisseurs (commissions)",
  ticket_details_company_commission: "Billets — commission détachée",
  proforma_ticket_details_company_commission: "Billets proforma — commission détachée",
  penalties: "Pénalités",
  payments: "Paiements",
  installments: "Échéances",
  delivery_notes: "Bons de livraison",
  ticket_details: "Détails billets",
  shop_details: "Détails articles",
  invoice_lines: "Lignes de facture",
  proforma_ticket_details: "Détails billets (proforma)",
  proforma_shop_details: "Détails articles (proforma)",
  proforma_lines: "Lignes de proforma",
  invoices: "Factures",
  proformas: "Proformas",
  commission_edit_requests: "Demandes de modification (commissions)",
  commission_transactions: "Transactions de commission",
  stock_edit_requests: "Demandes de modification (stock)",
  stock_movements: "Mouvements de stock",
  stock_items: "Articles en stock",
  stock_articles: "Articles PrestiShop",
  mail_outbox: "File d'envoi e-mails",
  notifications: "Notifications",
  audit_log: "Journal d'audit",
  parties: "Parties",
  credit_lots_source_invoice: "Crédits — facture source détachée",
  savings_transactions_invoice: "Épargne — facture détachée",
  shop_details_article: "Détails articles — article détaché",
  proforma_shop_details_article: "Détails articles (proforma) — article détaché",
  counters: "Compteurs de documents",
};

export function cleanupResultLabel(rawKey: string): string {
  return CLEANUP_RESULT_LABELS[rawKey] ?? rawKey;
}
